/**
 * Arquivos colados com Ctrl+V (ex.: print da tela) — usado pelos campos de
 * texto que aceitam anexo (mensagem de Ocorrências, descrição e resposta de
 * problema no Atendimento HUB). Vazio quando o colado é texto, e aí o
 * chamador deixa o paste seguir normal.
 *
 * Word/Excel/Outlook copiam o trecho como texto E como uma imagem PNG dele;
 * o navegador expõe essa imagem como arquivo. Sem o corte por `text/rtf`
 * (marca do rich text do Office), colar um parágrafo ou células viraria um
 * anexo de imagem e o texto sumiria. Print, imagem copiada do navegador e
 * arquivo copiado do Finder/Explorer não trazem RTF e seguem como anexo.
 */
export function filesFromClipboard(data: DataTransfer): File[] {
  if (Array.from(data.types ?? []).includes('text/rtf')) return []
  const files: File[] = []
  for (const item of Array.from(data.items)) {
    if (item.kind !== 'file') continue
    const file = item.getAsFile()
    if (file) files.push(file)
  }
  return files
}
